/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AnalyticsInputs */

const en_admin_settings_tabs_analytics = /** @type {(inputs: Admin_Settings_Tabs_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const zh_admin_settings_tabs_analytics = /** @type {(inputs: Admin_Settings_Tabs_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Admin_Settings_Tabs_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_analytics = /** @type {((inputs?: Admin_Settings_Tabs_AnalyticsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AnalyticsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_analytics(inputs)
	return zh_admin_settings_tabs_analytics(inputs)
});
export { admin_settings_tabs_analytics as "admin.settings.tabs.analytics" }